import { GretaAIChatFinanceAccess } from './GretaAIChat.constants'
import { getIsGretaAIChatFinanceSource } from './GretaAIChat.utils.source'

export function getIsGretaAIChatSourceChoiceEnabled(financeAccess) {
  return financeAccess.access !== GretaAIChatFinanceAccess.NoAccess
}

export function getIsGretaAIChatFinanceAvailable(financeAccess) {
  return financeAccess.access === GretaAIChatFinanceAccess.Available
}

export function getIsGretaAIChatFinanceNotBought(financeAccess) {
  return financeAccess.access === GretaAIChatFinanceAccess.NotBought
}

export function getIsGretaAIChatFinanceNew(financeAccess) {
  return (
    !financeAccess.isStale &&
    ((getIsGretaAIChatFinanceAvailable(financeAccess) &&
      !financeAccess.isUsed) ||
      (getIsGretaAIChatFinanceNotBought(financeAccess) &&
        !financeAccess.isPreviewSeen))
  )
}

export function getIsGretaAIChatSourceRevoked({
  financeAccess,
  isPinned,
  source,
}) {
  return (
    isPinned &&
    getIsGretaAIChatFinanceSource(source) &&
    !getIsGretaAIChatFinanceAvailable(financeAccess) &&
    !financeAccess.isStale
  )
}

export function getIsGretaAIChatFinancePreview({
  financeAccess,
  isPinned,
  source,
}) {
  return (
    !isPinned &&
    getIsGretaAIChatFinanceSource(source) &&
    getIsGretaAIChatFinanceNotBought(financeAccess)
  )
}

export function getIsGretaAIChatFinancePreviewPick({ financeAccess, source }) {
  return (
    getIsGretaAIChatFinanceNotBought(financeAccess) &&
    getIsGretaAIChatFinanceSource(source)
  )
}
